<template>
  <i class="fas fa-pen cursor-pointer text-blue-800"></i>
</template>

<script>
export default {

}
</script>

<style>
</style>
